import Button from '@atlaskit/button/loading-button';
import AkForm, { FormFooter } from '@atlaskit/form';
import { Box, xcss } from '@atlaskit/primitives';
import { ExternalLink, FluidContainer, useMpacConfiguration } from '@atlassian/mpac-primitives';
import { MPAC_CONFIGURATION_KEYS } from '@atlassian/mpac-types';
import { TextInput } from '@atlassian/mpac-ui';
import React from 'react';

import MemoizedGetConfiguratorComponentById from './GetConfiguratorComponentById';

const resultBoxStyles = xcss({
  marginTop: 'space.300',
  marginBottom: 'space.300',
});

const AdminConfigurator = () => {
  const { mpacConfiguration, getSectionConfiguration, bulkUpdateConfiguration } =
    useMpacConfiguration();

  const handleSubmit = (formState) => {
    bulkUpdateConfiguration(formState, Object.keys(MPAC_CONFIGURATION_KEYS));
  };

  const mpacConfigurationKeys = Object.keys(MPAC_CONFIGURATION_KEYS);

  const configHelperMessage = (
    <>
      Copy this JSON config and use it in{' '}
      <ExternalLink
        href="https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/mpac_configurator"
        size="small"
      >
        Statsig configuration
      </ExternalLink>{' '}
      to update the app.
      <br />
    </>
  );

  return (
    <FluidContainer>
      <AkForm onSubmit={handleSubmit}>
        {({ formProps }) => (
          <form {...formProps} data-testid="app-configurator-form">
            {mpacConfigurationKeys.map((mpacKey) => (
              <MemoizedGetConfiguratorComponentById
                key={mpacKey}
                id={mpacKey}
                getSectionConfiguration={getSectionConfiguration}
              />
            ))}
            <FormFooter align="start">
              <Button testId="app-configurator-save-button" type="submit" appearance="primary">
                Generate Config
              </Button>
            </FormFooter>
          </form>
        )}
      </AkForm>
      <Box xcss={resultBoxStyles}>
        <TextInput
          key={JSON.stringify(mpacConfiguration)}
          label="Service Configuration"
          placeholder="Click on 'Generate Config' to get the JSON"
          fieldType="textarea"
          name="serviceConfigJSON"
          defaultValue={JSON.stringify(mpacConfiguration)}
          helperMessage={configHelperMessage}
          isDisabled
        />
      </Box>
    </FluidContainer>
  );
};

export default AdminConfigurator;
